import * as $ from "jquery";
import { getParameterByName, setupShowButton } from "./standard";

export class CampusOrgDetails {
    constructor() {
        setupShowButton($("#butAttachmentShow"), $(".hiddenattach"));
        setupShowButton($("#butMembersShow"), $(".hiddenmembers"));
        setupShowButton($("#butPartnerShow"), $(".hiddenpartner"));
        setupShowButton($("#butScholarshipShow"), $(".hiddenscholarships"));
        setupShowButton($("#butLogShow"), $(".hiddenlog"));
        setupShowButton(
            $("#butShowHiddenStudentContacts"),
            $("#contactstudent .hiddencontact"),
            " Hidden",
        );
        setupShowButton(
            $("#butShowInactiveStudentContacts"),
            $("#contactstudent .inactivecontact"),
            " Inactive",
        );
        setupShowButton(
            $("#butShowHiddenFacultyContacts"),
            $("#contactofficer .hiddencontact"),
            " Hidden",
        );
        setupShowButton(
            $("#butShowInactiveFacultyContacts"),
            $("#contactofficer .inactivecontact"),
            " Inactive",
        );
        setupShowButton(
            $("#butShowHiddenMembership"),
            $(".membershipline:hidden"),
            " Hidden",
        );

        const paramShow = getParameterByName("show");
        if (paramShow == "addcontactstudent") {
            $("#butShowHiddenStudentContacts").trigger("click");
        } else if (paramShow == "addcontactfaculty") {
            $("#butShowHiddenFacultyContacts").trigger("click");
        }

        this.setupTermExpand();
    }

    setupTermExpand() {
        $(".info-term").on("click", function () {
            const $tr = $(this).closest("tr");
            const nextclass = $tr.attr("class");
            const $trnext = $tr.next();
            if ($trnext.length == 0 || !$trnext.hasClass("info-data")) {
                const corgtermid = parseInt($(this).data("id"));
                //console.log("id:" + corgtermid);

                const $trnext = $(
                    "<tr class='info-data " + nextclass +
                        "'><td colspan='6'><div class='inside'></div></td></tr>",
                );
                $trnext.insertAfter($tr);

                $.post(
                    "/campus/CampusOrgTermExpand.ashx?CampusOrgTermID=" +
                        corgtermid,
                    function (data) {
                        let datatable = "<table>";

                        if (data.length > 0) {
                            $.each(data, function (index, value) {
                                datatable += "<tr><td class='caption'>" +
                                    value.caption + ":</td><td class='data'>" +
                                    value.value + "</td></tr>";
                            });
                        } else {
                            datatable +=
                                "<tr><td><em>No additional information.</em></td></tr>";
                        }

                        datatable += "</table>";
                        const $datainfo = $trnext.find(".inside");
                        $datainfo.append(datatable);
                    },
                );
            }

            $trnext.toggleClass("expand");
        });
    }

    setupMemberSort($members: JQuery) {
        const self = this;
        $("#ddSort").on("change", function () {
            const rows = $members.find("tr.dgItem,tr.dgItemAlt").get();
            let compare = self.compareName;
            switch ($(this).val()) {
                case "name":
                    compare = self.compareName;
                    break;
                case "grad":
                    compare = self.compareGradYear;
                    break;
                case "date":
                    compare = self.compareDate;
                    break;
            }
            rows.sort(compare);
            for (var row of rows) {
                $members.children().append(row);
            }
        });
    }

    setupFavorite(campusOrganizationID: number, instructorID: number) {
        const $favbutton = $("#orgfavorite");

        const checkData = {
            CampusOrgID: campusOrganizationID,
            InstructorID: instructorID,
        };

        $.post(
            "CampusOrgFavoriteGet.ashx",
            JSON.stringify(checkData),
            function (data) {
                const isFavorite = parseInt(data) != 0;
                $favbutton.toggleClass("checked", isFavorite);
            },
        );

        $favbutton.on("click", function () {
            const isChecked = $favbutton.hasClass("checked");
            const newChecked = !isChecked;
            $favbutton.toggleClass("checked", newChecked);

            const sendData = {
                CampusOrgID: campusOrganizationID,
                InstructorID: instructorID,
                set: newChecked,
            };

            $.post(
                "CampusOrgFavoriteChange.ashx",
                JSON.stringify(sendData),
                function (data) {
                    // do nothing
                },
            );
        });
    }

    // compare by added date
    compareDate(a: HTMLElement, b: HTMLElement): number {
        const A = new Date($(a).children("td").eq(3).text());
        const B = new Date($(b).children("td").eq(3).text());
        if (A > B) {
            return -1;
        }
        if (A < B) {
            return 1;
        }
        return this.compareName(a, b);
    }

    // compare by grad year
    compareGradYear(a: HTMLElement, b: HTMLElement): number {
        let A = parseInt($(a).children("td").eq(2).text());
        let B = parseInt($(b).children("td").eq(2).text());

        if (!A) A = 0;
        if (!B) B = 0;

        if (A > B) {
            return -1;
        }
        if (A < B) {
            return 1;
        }
        return this.compareName(a, b);
    }

    // compare by name
    compareName(a: HTMLElement, b: HTMLElement): number {
        const A = $(a).children("td").eq(0).text().toUpperCase();
        const B = $(b).children("td").eq(0).text().toUpperCase();
        if (A < B) {
            return -1;
        }
        if (A > B) {
            return 1;
        }
        let A2 = $(a).children("td").eq(1).text().toUpperCase();
        let B2 = $(b).children("td").eq(1).text().toUpperCase();
        if (A2 < B2) {
            return -1;
        }
        if (A2 > B2) {
            return 1;
        }
        return 0;
    }
}
